var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root gig-loader"},[_c('div',{staticClass:"cards-container"},_vm._l((6),function(i){return _c('div',{key:i,staticClass:"child-card"},[_c('lx-loader-new')],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }